import * as React from "react";
let warnedOnce = false;

const warn = () => {
  if (!warnedOnce) {
    console.warn(
      [
        "Vapor: The CurrencyTextField component has moved from `@vapor/react-material` to `@vapor/react-custom`.",
        "",
        "Now the name of the component is `VaporCurrencyField`",
        "",
        "For more information you may check Vapor Custom CHANGELOG https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  }

  warnedOnce = true;
};

export const CurrencyTextField = React.forwardRef((props: any, ref: any) => {
  warn();
  return null;
});
